import React from 'react'
import logo from '../../assets/image/logo.png';
import chessimg14 from '../../assets/image/chessimg14.jpeg';

const TheIntermediateCourse = () => {
    return (


        <div>
            <div id="preloader-active">
                <div className="preloader d-flex align-items-center justify-content-center">
                    <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

        
            <main>

                <div class="slider-area ">
                    <div
                        className="single-slider hero-overly slider-height d-flex align-items-center"
                        style={{
                            backgroundImage: `url('${chessimg14}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hero-cap">
                                        <h2>The Intermediate Course</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                                <li class="breadcrumb-item"><a href="#">Courses</a></li>
                                                <li class="breadcrumb-item"><a href="#">The Intermediate Course</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div style={{ marginLeft: '100px' }}>
                    <div class="section-tittle mb-80">
                        <span>All that is included in this course - </span>
                        <h2>THE INTERMEDIATE COURSE</h2>
                    </div>
                    <div class="history-tl-container">
                        <ul class="tl">
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Classical Chess Openings</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Modern Chess Openings</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Mate in 2 moves</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Concept Of Opposition</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Introduction to checks</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King-Pawn v/s King</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King-Queen v/s King and pawn on 7th rank</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Lucena Position</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Philidor Position</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Knight Fork - Level 2</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Double Attack - Level 2</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title"> Skewer - Level 2</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Pin - Level 2</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Discovered checks and attacks - Level 2</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Destroying the defender - Level 2</div>

                            </li>
                        </ul>

                    </div>
                </div>
            </main>

         
            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
        </div>

    )
}

export default TheIntermediateCourse